import { getCSRFToken } from '@view/utils/getCSRFToken'

export const headersConfig = {
	headers: {
		'x-react': 'useReact',
		'Content-Type': 'application/json',
	},
}
export const postConfig = (body: unknown) => ({
	method: 'POST',
	body: JSON.stringify(body),
	headers: {
		'x-react': 'useReact',
		'Content-Type': 'application/json',
		'X-CSRF-Token': getCSRFToken(),
	},
})
export const parseMoneyString = (str: string) => (str ? parseFloat(str.replace(/,/gi, '')) : 0)
/* 
? formats date like : day/month/year
? returns time strings
? ie formatted for res form 
 */
export const computeTime = (date: Date, time: string | null) => {
	const day = new Date(date)
	const [hours, minutes] = time ? time.split(':') : [null, null]
	day.setHours(Number(hours))
	day.setMinutes(Number(minutes))
	const dayString = `${day.getDate() < 10 ? '0' : ''}${day.getDate()}/${day.getMonth() + 1 < 10 ? '0' : ''}${
		day.getMonth() + 1
	}/${day.getFullYear()}`
	return {
		day: dayString,
		hours,
		minutes,
	}
}

export const setReducer = reducer => state => action => reducer(state, action)
